module.exports = __webpack_public_path__ + "img/2.56b4939d.jpg";